<template>
    <div>
        <div v-if="!expanded" class="fake-youtube-container" @click="expanded = true">
            <img :src="`https://img.youtube.com/vi/${videoCode}/0.jpg`"/>

            <i class="fa fa-youtube-play fa-stack-1x"></i>
            <i class="fa fa-youtube-play fa-stack-1x"></i>

        </div>


        <div v-if="expanded" class="youtube-iframe-wrapper">
            <iframe class="real-youtube-container" :src="`https://www.youtube.com/embed/${videoCode}?autoplay=1`" frameborder="0" allowfullscreen></iframe>
        </div>

    </div>
</template>


<script>
    export default {
        name: 'FakeYoutube',
        props: ['src'],

        data(){
            return {
                expanded: false
            }
        },

        computed: {
            videoCode(){
                return this.src;

                let matched = this.src.match("v=([a-zA-Z0-9\_\-]+)&?");

                if (matched && matched.length > 1) {
                    return matched[1];
                } else {
                    return this.src.split('/')[this.src.split('/').length - 1];
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// FakeYoutube.vue?1c9d73de